import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import styled from "styled-components";
import axios from "axios";
import Button from "@mui/material/Button";
import Moment from 'moment';
import Swal from "sweetalert2";
import '../../../../css/datagrid.css';
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import { useParams } from 'react-router-dom';
import { useNavigate, useLocation } from "react-router-dom";

const MachineProducePerformanceInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [selectDateType, setSelectDateType] = useState('E');
    const [dateTypeOption, setDateTypeOption] = useState([{ value: 'S', label:'시작일자' },{ value: 'E', label:'종료일자' }]);
    const [selectDate, setSelectDate] = useState(appStore.YYYY_MM_DD());
    const [fixProject, setFixProject] = useState(''); // 고정 데이터
    const [searchProject, setSearchProject] = useState('');// 조회 데이터
    const [selectProject, setSelectProject] = useState('');
    const [selectProduceInputUserID, setSelectProduceInputUserID] = useState(0);
    const [selectProduceInputDateTime, setSelectProduceInputDateTime] = useState('');
    const [selectProduceInputYN, setSelectProduceInputYN] = useState('');
    const [selectProduceItemUseYN, setSelectProduceItemUseYN] = useState('');
    const [selectProduceCount, setSelectProduceCount] = useState(0);
    const [selectProduceCompleteCount, setSelectProduceCompleteCount] = useState(0);
    const [selectProduceErrorCount, setSelectProduceErrorCount] = useState(0);
    const [projectOption, setProjectOption] = useState([]);
    const [InputItemRows, setInputItemRows] = useState([]);
    const [machineOption, setMachineOption] = useState([]);
    const [searchProjectOption, setSearchProjectOption] = useState([]);
    const [searchPerformanceOption, setSearchPerformanceOption] = useState([
        {value:'Y', label:'실적등록'}
        ,{value:'N', label:'실적미등록'}
    ]);
    const [selectSearchMachineID, setSelectSearchMachineID] = useState('');
    const [selectSearchProjectID, setSelectSearchProjectID] = useState('');
    const [selectSearchStartDate, setSelectSearchStartDate] = useState(appStore.YYYY_MM_01());
    const [selectSearchEndDate, setSelectSearchEndDate] = useState(appStore.YYYY_MM_DD());
    const [selectSearchPerforamnce, setSelectSearchPerforamnce] = useState('N');
    const [selectProjectItemID, setSelectProjectItemID] = useState('');
    const [selectWidth, setSelectWidth] = useState('calc(100% - 320px)');
    const [columns, setColumns] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        machine_project_id: false,
        machine_id: false,
        machine_name: true,
        project_name: true,
        project_product_name: true,
        produce_start_datetime: true,
        produce_end_datetime: true,
        produce_bom_id: false,
        produce_bom_name: false,
        produce_item_id: false,
        produce_item_name: true,
        produce_item_spec: true,
        produce_count: true,
        produce_complete_count: true,
        produce_error_count: true,
        produce_input_yn: false,
        produce_input_user_name: true,
        produce_input_datetime: true
    });
    const [columnItemsVisibilityModel, setColumnItemsVisibilityModel] = useState({
        id: false,
        item_id: false,
        item_name: true,
        item_spec: true,
        item_plan_count: true,
        item_count: true
    });
    const [columnsItems, setColumnsItems] = useState([]);
    const [itemRows, setItemRows] = useState([]);

    useEffect(() => {
        setTimeout(() => { // 초기 화면인 경우 늦게 표시 됨.
            const accessList = JSON.parse(localStorage.getItem("nav"));
            if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
                setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
                setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
                setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
                setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
                setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
                setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
            } else {
                Swal.fire({
                    title: '<p style="color:red">접근 권한 오류</p>',
                    text: '화면에 접근 권한이 없습니다.',
                    confirmButtonText: '확인',
                    confirmButtonColor: '#7066e0',
                    timer: 5000,
                    timerProgressBar: true
                }).then((value) => {
                    return navigate(-1);
                });
            }
        }, 800);
    }, []);

    useEffect(() => {
        // Mount 될때만 실행된다.
        if(params.project_id !== null && typeof params.project_id !== 'undefined'){
            setFixProject(params.project_id);
            setSearchProject(params.project_id);
        }
    }, []);

    useEffect(() => {
        setSelectProject(0);
        setSelectProduceInputUserID(0);
        setSelectProduceInputDateTime('');
        setSelectProduceInputYN('');
        setSelectProduceCount(0);
        setSelectProduceCompleteCount(0);
        setSelectProduceErrorCount(0);
        setProjectOption([]);
        setInputItemRows([]);
        handleInitSelect();
    }, [selectDateType, selectDate]);
    
    useEffect(() => {
        if(String(searchProject) !== ''){
            if(String(searchProject) !== String(selectProject)){
                setSelectProject(searchProject);
            }else{
                handleSelect();
            }
        }
    }, [searchProject]);

    useEffect(() => {
        if(selectProject == 0 || selectProject === ''){
            setSelectProduceInputUserID(0);
            setSelectProduceInputDateTime('');
            setSelectProduceInputYN('');
            setSelectProduceCount(0);
            setSelectProduceCompleteCount(0);
            setSelectProduceErrorCount(0);
            setInputItemRows([]);
        }else{
            handleSelect();
        }
    }, [selectProject]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleListSelect();
        }
    }, [MenuID])

    useEffect(() => {
        // 조회조건 수정 후 조회
        handleListSelect();
        if(selectSearchPerforamnce === 'Y'){
            setSelectWidth('960px');
        }else{
            setSelectWidth('calc(100% - 320px)');
        }
    }, [selectSearchMachineID, selectSearchProjectID, selectSearchStartDate, selectSearchEndDate, selectSearchPerforamnce]);

    useEffect(() => {
        // 조회조건 수정 후 조회
        handleItemListSelect();
    }, [selectProjectItemID]);

    const handleSetting = () => {
        setColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'machine_project_id', headerName: 'machine_project_id', width: 0, headerAlign: 'center' },
            { field: 'machine_id', headerName: 'machine_id', width: 0, headerAlign: 'center' },
            { field: 'machine_name', headerName: '설비명', width: 170, headerAlign: 'center' },
            { field: 'project_name', headerName: '프로젝트명', width: 120, headerAlign: 'center', align:'center' },
            { field: 'project_product_name', headerName: '프로젝트 제품명', width: 200, headerAlign: 'center', align:'left' },
            { field: 'produce_start_datetime', headerName: '생산시작일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'produce_end_datetime', headerName: '생산종료일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'produce_count', headerName: '생산수량', width: 100, headerAlign: 'center', align:'right' },
            { field: 'produce_complete_count', headerName: '양품수량', width: 100, headerAlign: 'center', align:'right' },
            { field: 'produce_error_count', headerName: '불량수량', width: 100, headerAlign: 'center', align:'right' },
            { field: 'produce_bom_id', headerName: 'produce_bom_id', width: 0, headerAlign: 'center', align:'left' },
            { field: 'produce_bom_name', headerName: 'BOM', width: 150, headerAlign: 'center', align:'left' },
            { field: 'produce_item_id', headerName: 'produce_item_id', width: 0, headerAlign: 'center', align:'left' },
            { field: 'produce_item_name', headerName: '생산품', width: 150, headerAlign: 'center', align:'left' },
            { field: 'produce_item_spec', headerName: '생산규격', width: 300, headerAlign: 'center', align:'left' },
            { field: 'produce_input_user_name', headerName: '실적등록자', width: 130, headerAlign: 'center', align:'center' },
            { field: 'produce_input_datetime', headerName: '실적등록일시', width: 180, headerAlign: 'center', align:'center' }
        ]);

        setColumnsItems([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'item_id', headerName: 'item_id', width: 0, headerAlign: 'center' },
            { field: 'item_name', headerName: '사용품목', width: 150, headerAlign: 'center', align:'left' },
            { field: 'item_spec', headerName: '사용품목규격', width: 250, headerAlign: 'center', align:'left' },
            { field: 'item_plan_count', headerName: 'BOM수량', width: 100, headerAlign: 'center', align:'right' },
            { field: 'item_count', headerName: '사용수량', width: 100, headerAlign: 'center', align:'right' },
        ]);
    };

    const ProduceInputCountUpdate = (produceInputItemSeq, e, useStock, DPuseStock, UnitName) => {
        const {name, value} = e.target;
        if(Number(value) > Number(useStock)){
            Swal.fire({
                title: '<p style="color:red">사용 수량 변경 오류</p>',
                html: '사용가능재고가 '+DPuseStock+UnitName+'이므로 '+DPuseStock+UnitName+'까지 변경할 수 있습니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
            });
            setInputItemRows(InputItemRows.map(
                InputItemRows=>InputItemRows.produce_input_item_seq === produceInputItemSeq ? {...InputItemRows, produce_input_count:useStock} : InputItemRows
            ));
        }else{
            setInputItemRows(InputItemRows.map(
                InputItemRows=>InputItemRows.produce_input_item_seq === produceInputItemSeq ? {...InputItemRows, produce_input_count:value} : InputItemRows
            ));
        }
    };

    const ProduceCompleteCountUpdate = (e) => {
        if(selectProject === '' || selectProject === 0){
            Swal.fire({
                title: '<p style="color:red">수량 변경 오류</p>',
                html: '프로젝트 선택 후 수량 변경이 가능합니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
            });
            return;
        }

        const {name, value} = e.target;

        var minus = (Number(value))
        if(minus < 0){
            minus = 0
        }

        setSelectProduceCompleteCount(minus);
    };

    const ProduceErrorCountUpdate = (e) => {
        if(selectProject === '' || selectProject === 0){
            Swal.fire({
                title: '<p style="color:red">수량 변경 오류</p>',
                html: '프로젝트 선택 후 수량 변경이 가능합니다.',
                confirmButtonText: '확인',
                timer:5000,
                timerProgressBar: true
            });
            return;
        }

        const {name, value} = e.target;

        var minus = (Number(value))
        if(minus < 0){
            minus = 0
        }

        setSelectProduceCompleteCount(Number(selectProduceCount) - Number(minus));
        if(minus === 0){
            minus = '';
        }
        setSelectProduceErrorCount(minus);
    };

    const handleInitSelect = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/SelectCommon/MachineList')
        .then((response) => {
            const optionArray = (response.data ?? [])
            .filter(item => String(item.machine_type) === '1') 
            .map(item => ({ value: item.machine_id, label: item.machine_name }));

            optionArray.unshift({ value: 0, label : '설비'});
            setMachineOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        });

        axios.get('/api/p/MachineProducePerformance/SelectAllProject')
        .then((response) => {
            const optionArray = response.data.map((item, index) => 
                ({ value: item.machine_project_id, label: item.project_name })
            );
            optionArray.unshift({ value: 0, label : '프로젝트'});
            setSearchProjectOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        });

        axios.get('/api/p/MachineProducePerformance/Select',
            {
                params : {
                    date : selectDate,
                    date_type : selectDateType
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            const optionArray = response.data.map((item, index) => 
                ({ value: item.machine_id+'$'+item.machine_project_id+'$'+Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')+'$'+Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss'), label: item.machine_name + ' / ' + item.project_name + ' / ' + item.produce_count+'EA' })
            );
            optionArray.unshift({ value: 0, label : '설비 / 프로젝트 / 생산수량' });
            setProjectOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    const handleSelect = () => {
        setSearchProject('');
        const param_machine_id = (selectProject.split("$"))[0]
        const param_machine_project_id = (selectProject.split("$"))[1]
        const param_produce_start_datetime = (selectProject.split("$"))[2]
        const param_produce_end_datetime = (selectProject.split("$"))[3]
        
        axios.get('/api/p/MachineProducePerformance/SelectProject',
            {
                params : {
                    machine_id : param_machine_id,
                    machine_project_id : param_machine_project_id,
                    produce_start_datetime : param_produce_start_datetime,
                    produce_end_datetime : param_produce_end_datetime
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            setSelectProduceInputYN(typeof (response.data)[0].produce_input_yn === 'undefined'? "":(response.data)[0].produce_input_yn);
            setSelectProduceItemUseYN(typeof (response.data)[0].produce_item_use_yn === 'undefined'? "":(response.data)[0].produce_item_use_yn);
            setSelectProduceCount(typeof (response.data)[0].produce_count === 'undefined' || Number((response.data)[0].produce_count) === 0? 0:(response.data)[0].produce_count);
            setSelectProduceCompleteCount(typeof (response.data)[0].produce_complete_count === 'undefined' || Number((response.data)[0].produce_complete_count) === 0? (response.data)[0].produce_count:(response.data)[0].produce_complete_count);
            if(String((response.data)[0].produce_input_yn) === 'Y'){
                setSelectProduceErrorCount(typeof (response.data)[0].produce_error_count === 'undefined' || Number((response.data)[0].produce_error_count) === 0? '0':(response.data)[0].produce_error_count);
            }else{
                setSelectProduceErrorCount(typeof (response.data)[0].produce_error_count === 'undefined' || Number((response.data)[0].produce_error_count) === 0? '':(response.data)[0].produce_error_count);
            }
            setSelectProduceInputUserID(typeof (response.data)[0].produce_input_user_id === 'undefined'? "":String((response.data)[0].produce_input_user_id));
            setSelectProduceInputDateTime(typeof (response.data)[0].produce_input_datetime === 'undefined'? "":Moment((response.data)[0].produce_input_datetime).format('YYYY-MM-DD HH:mm:ss'));
            
            // 검색으로 들어오면 프로젝트 조회.
            if(fixProject !== ''){
                const optionArray = response.data.map((item, index) => 
                    ({ value: item.machine_id+'$'+item.machine_project_id+'$'+Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')+'$'+Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss'), label: item.machine_name + ' / ' + item.project_name + ' / ' + item.produce_count+'EA' })
                );
                
                setProjectOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
            }

            let array = response.data.map((item, index) => ({
                produce_input_item_seq: (typeof item.produce_input_item_seq === 'undefined'? "":String(item.produce_input_item_seq)),
                produce_input_item_id: (typeof item.produce_input_item_id === 'undefined'? "":String(item.produce_input_item_id)),
                produce_input_item_name: (typeof item.produce_input_item_name === 'undefined'? "":String(item.produce_input_item_name)),
                produce_input_plan_count: (typeof item.produce_input_plan_count === 'undefined'? "0":String(item.produce_input_plan_count)),
                produce_input_count: (
                    (response.data)[0].produce_input_yn === "Y"?
                    Number(item.produce_input_count)
                    :
                    (Number(item.produce_input_plan_count) >= Number(item.produce_input_item_use_stock)?Number(item.produce_input_item_use_stock):Number(item.produce_input_plan_count))
                ),
                produce_input_item_spec: (typeof item.produce_input_item_spec === 'undefined'? "":String(item.produce_input_item_spec)),
                produce_input_item_full_spec: item.produce_input_item_spec,
                produce_input_item_width: item.produce_input_item_width,
                produce_input_item_depth: item.produce_input_item_depth,
                produce_input_item_height: item.produce_input_item_height,
                produce_input_item_use_stock: item.produce_input_item_use_stock,
                produce_input_item_dp_use_stock: item.produce_input_item_dp_use_stock,
                produce_input_item_unit_name: item.produce_input_item_unit_name
            }));
            array = array.filter((element) => element.produce_input_plan_count > 0);
            setInputItemRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const handleListSelect = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        setRows([]);
        setOriginRows([]);
        
        axios.get('/api/p/MachineProducePerformance/SelectSearchProject',
            {
                params : {
                    machine_id : selectSearchMachineID,
                    project_id : selectSearchProjectID,
                    input_yn : selectSearchPerforamnce,
                    input_start_date : selectSearchStartDate,
                    input_end_date : selectSearchEndDate
                }
            },
            { withCredentials: true }
        )
        .then((response) => {

            const array = response.data.map((item, index) => ({
                id: item.machine_id+'$'+item.machine_project_id+'$'+Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')+'$'+Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss'),
                machine_project_id: item.machine_project_id,
                machine_id: item.machine_id,
                machine_name: String(item.machine_name),
                project_name: String(item.project_name),
                project_product_name: (typeof item.project_product_name === 'undefined'? "":item.project_product_name),
                produce_start_datetime: (typeof item.produce_start_datetime === 'undefined'? "":Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')),
                produce_end_datetime: (typeof item.produce_end_datetime === 'undefined'? "":Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss')),
                produce_bom_id: (typeof item.produce_bom_id === 'undefined'? "":String(item.produce_bom_id)),
                produce_bom_name: (typeof item.produce_bom_name === 'undefined'? "":String(item.produce_bom_name)),
                produce_item_id: (typeof item.produce_item_id === 'undefined'? "":String(item.produce_item_id)),
                produce_item_name: (typeof item.produce_item_name === 'undefined'? "":String(item.produce_item_name)),
                produce_item_spec: appStore.ITEM_FULL_SPEC_MAKE((typeof item.produce_item_spec === 'undefined' || item.produce_item_spec === ''? "": String(item.produce_item_spec, item.produce_item_width, item.produce_item_depth, item.produce_item_height))),
                produce_count: (typeof item.produce_count === 'undefined'? "0":String(item.produce_count)),
                produce_complete_count: (typeof item.produce_complete_count === 'undefined'? "0":String(item.produce_complete_count)),
                produce_error_count: (typeof item.produce_error_count === 'undefined'? "0":String(item.produce_error_count)),
                produce_input_yn: (typeof item.produce_input_yn === 'undefined'? "":String(item.produce_input_yn)),
                produce_input_user_name: (typeof item.produce_input_user_name === 'undefined'? "":String(item.produce_input_user_name)),
                produce_input_datetime: (typeof item.produce_input_datetime === 'undefined'? "":Moment(item.produce_input_datetime).format('YYYY-MM-DD HH:mm:ss'))
            }));


            const arrayOrigin = response.data.map((item, index) => ({
                id: item.machine_id+'$'+item.machine_project_id+'$'+Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')+'$'+Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss'),
                machine_project_id: item.machine_project_id,
                machine_id: item.machine_id,
                machine_name: String(item.machine_name),
                project_name: String(item.project_name),
                project_product_name: (typeof item.project_product_name === 'undefined'? "":item.project_product_name),
                produce_start_datetime: (typeof item.produce_start_datetime === 'undefined'? "":Moment(item.produce_start_datetime).format('YYYY-MM-DD HH:mm:ss')),
                produce_end_datetime: (typeof item.produce_end_datetime === 'undefined'? "":Moment(item.produce_end_datetime).format('YYYY-MM-DD HH:mm:ss')),
                produce_bom_id: (typeof item.produce_bom_id === 'undefined'? "":String(item.produce_bom_id)),
                produce_bom_name: (typeof item.produce_bom_name === 'undefined'? "":String(item.produce_bom_name)),
                produce_item_id: (typeof item.produce_item_id === 'undefined'? "":String(item.produce_item_id)),
                produce_item_name: (typeof item.produce_item_name === 'undefined'? "":String(item.produce_item_name)),
                produce_item_spec: (typeof item.produce_item_spec === 'undefined'? "":String(item.produce_item_spec)),
                produce_count: (typeof item.produce_count === 'undefined'? "0":String(item.produce_count)),
                produce_complete_count: (typeof item.produce_complete_count === 'undefined'? "0":String(item.produce_complete_count)),
                produce_error_count: (typeof item.produce_error_count === 'undefined'? "0":String(item.produce_error_count)),
                produce_input_yn: (typeof item.produce_input_yn === 'undefined'? "":String(item.produce_input_yn)),
                produce_input_user_name: (typeof item.produce_input_user_name === 'undefined'? "":String(item.produce_input_user_name)),
                produce_input_datetime: (typeof item.produce_input_datetime === 'undefined'? "":Moment(item.produce_input_datetime).format('YYYY-MM-DD HH:mm:ss')),
                produce_input_item_seq: (typeof item.produce_input_item_seq === 'undefined'? "":String(item.produce_input_item_seq)),
                produce_input_item_id: (typeof item.produce_input_item_id === 'undefined'? "":String(item.produce_input_item_id)),
                produce_input_item_name: (typeof item.produce_input_item_name === 'undefined'? "":String(item.produce_input_item_name)),
                produce_input_item_spec: (typeof item.produce_input_item_spec === 'undefined'? "":String(item.produce_input_item_spec)),
                produce_input_item_width: (typeof item.produce_input_item_width === 'undefined'? "":String(item.produce_input_item_width)),
                produce_input_item_height: (typeof item.produce_input_item_height === 'undefined'? "":String(item.produce_input_item_height)),
                produce_input_item_depth: (typeof item.produce_input_item_depth === 'undefined'? "":String(item.produce_input_item_depth)),
                produce_input_plan_count: (typeof item.produce_input_plan_count === 'undefined'? "":String(item.produce_input_plan_count)),
                produce_input_count: (typeof item.produce_input_count === 'undefined'? "":String(item.produce_input_count)),
                produce_input_item_unit_name: (typeof item.produce_input_item_unit_name === 'undefined'? "":String(item.produce_input_item_unit_name))
            }));
            
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
            setOriginRows([ ...new Set((arrayOrigin).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    const handleItemListSelect = () => {
        if(selectProjectItemID !== ''){
            var itemArray = originRows.filter((item, index) => item.id === selectProjectItemID && typeof item.produce_input_item_id !== 'undefined' && item.produce_input_item_id !== null && item.produce_input_item_id !== "");
            setItemRows(itemArray.map((item, index) => ({
                id: item.produce_input_item_seq,
                item_id: item.produce_input_item_id,
                item_name: item.produce_input_item_name,
                item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.produce_input_item_spec, item.produce_input_item_width, item.produce_input_item_depth, item.produce_input_item_height),
                item_plan_count: item.produce_input_plan_count,
                item_count: item.produce_input_count
            })));
        }
    };

    const handleSave = () => {
        let msg = '';
        if(selectProduceInputYN === 'Y'){
            msg = '이미 실적 등록된 프로젝트 입니다.'
        }else if(selectProject === '' || selectProject === 0){
            msg = '프로젝트가 선택되지 않았습니다.'
        }else if(selectProduceCompleteCount < 0){
            msg = '양품수량이 음수가 될 수 없습니다.'
        }else if(selectProduceErrorCount < 0){
            msg = '불량수량이 음수가 될 수 없습니다.'
        }

        if(InputItemRows.length > 0 && msg === ''){ // 출하품목 검사
            for(let i = 0; i < InputItemRows.length; i++) {
                const input_count = InputItemRows[i].produce_input_count;

                if(input_count < 0) {
                    msg = '사용품목 수량이 음수가 될 수 없습니다.';
                    break;
                }
            }
        }
        if(msg !== ''){
            Swal.fire({
                title: '<p style="color:red">생산 실적 등록 오류</p>',
                html: msg,
                confirmButtonText: '확인'
            });
        }else{
            if (appStore.loading) return;
            appStore.setLoading(true);
            
            axios.post("/api/p/MachineProducePerformance/Update", {selectProject, selectProduceCount, selectProduceCompleteCount, selectProduceErrorCount, InputItemRows},
            { withCredentials: true })
            .then(function (response) {
                if(response.data === "N"){
                    Swal.fire({
                        title: '생산 실적 등록 완료',
                        html: "정상적으로 생산 실적이 등록 되었습니다.",
                        confirmButtonText: '확인',
                        timer:5000,
                        timerProgressBar: true
                    })
                    setSearchProject(selectProject);
                    //window.location.reload();
                }else{
                    Swal.fire({
                        title: '<p style="color:red">생산 실적 등록 오류</p>',
                        html: response.data,
                        confirmButtonText: '확인'
                    });
                }
            })
            .catch(function (error) {
                appStore.capture();
            })
            .finally(() => {
                appStore.setLoading(false); 
            });
        }
    };

    const handleCancel = () => {
        let msg = '';
        if(selectProduceItemUseYN === 'Y'){
            msg = '생산된 제품이 이미 사용/출하 되었으므로 실적을 취소할 수 없습니다.'
        }

        if(msg !== ''){
            Swal.fire({
                title: '<p style="color:red">생산 실적 취소 오류</p>',
                html: msg,
                confirmButtonText: '확인'
            });
        }else{

            Swal.fire({
                title: '생산 실적 취소',
                text: '생산 실적을 취소 하시겠습니까?',
                showCancelButton: true,
                confirmButtonText: '예', 
                cancelButtonText: '아니오',
                confirmButtonColor: '#0067a3',
                cancelButtonColor: '#d33',
            }).then(result => {
                if (result.isConfirmed) {
                    if (appStore.loading) return;
                    appStore.setLoading(true);

                    axios.post("/api/p/MachineProducePerformance/Cancel", {selectProject},
                    { withCredentials: true })
                    .then(function (response) {
                        if(response.data === "N"){
                            Swal.fire({
                                title: '생산 실적 취소 완료',
                                html: "정상적으로 생산 실적이 취소 되었습니다.",
                                confirmButtonText: '확인',
                                timer:5000,
                                timerProgressBar: true
                            });
                            setSearchProject(selectProject);
                            //window.location.reload();
                        }else{
                            Swal.fire({
                                title: '<p style="color:red">생산 실적 취소 오류</p>',
                                html: response.data,
                                confirmButtonText: '확인'
                            });
                        }
                    })
                    .catch(function (error) {
                        appStore.capture();
                    })
                    .finally(() => {
                        appStore.setLoading(false); 
                    });
                }
            })
        }
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0)? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '70px', paddingRight: '0px' } }>
                <div className="menu-action" style={ { paddingRight: '0px' } }>
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                        {selectProduceInputYN === 'N'?
                        <>
                        <Button 
                            onClick={ handleSave }
                            className="btn-p"
                            sx={{
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            실적등록
                        </Button>
                        </>:
                        selectProduceInputYN === 'Y'?
                        <>
                        <Button 
                            onClick={ handleCancel }
                            className="btn-p"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "orange", 
                                backgroundColor: "orange",
                                ":hover": { boxShadow: "2px 2px 2px orange" , backgroundColor: "orange", borderColor: "orange"}
                            }} 
                            variant="outlined">
                            실적취소
                        </Button>
                        </>
                        :
                        <></>}
                    </div>
                </div>
            </div>
            <div className="grid" style={ { top:'73px' } }>
                <div style={ {  width: '100%' } }>
                    <div className="grid_sub" style={ { width: selectWidth, height: 'calc(100vh - 173px)', float: 'left' } }>
                        <div style={ { margin:'5px', fontSize: '20px', fontWeight: 'bold', height: '30px' } }>생산실적 조회</div>
                        <div style={ { display:'block', height:'50px' } }>
                            <div className="menu-keyword-sub-keyword" style={ { float: 'left' } }>
                                <select className="modal_filed_input_select" style={ { width: '200px', border:'2px solid lightgrey', borderRadius: '5px', fontSize:'15px', height:'40px' } } placeholder="일자" value={selectSearchMachineID} onChange={(e) => setSelectSearchMachineID(e.target.value) }>
                                    {machineOption.map((item) => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="menu-keyword-sub-keyword" style={ { float: 'left', paddingLeft: '30px' } }>
                                <select className="modal_filed_input_select" style={ { width: '120px', border:'2px solid lightgrey', borderRadius: '5px', fontSize:'15px', height:'40px' } } placeholder="일자" value={selectSearchProjectID} onChange={(e) => setSelectSearchProjectID(e.target.value) }>
                                    {searchProjectOption.map((item) => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="menu-keyword-sub-keyword" style={ { float: 'left', paddingLeft: '10px', fontSize:'15px', fontWeight:'bold' } }>
                                <select className="modal_filed_input_select" style={ { width: '120px', border:'2px solid lightgrey', borderRadius: '5px', fontSize:'15px', height:'40px' } } placeholder="일자" value={selectSearchPerforamnce} onChange={(e) => setSelectSearchPerforamnce(e.target.value) }>
                                    {searchPerformanceOption.map((item) => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                            </div>
                            {(selectSearchPerforamnce === 'Y')?
                            <>
                            <div className="menu-keyword-sub-keyword" style={ { float: 'left', width: '120px', paddingLeft: '10px' } }>
                                <input type="date" style={ { width: '120px', fontSize: '15px', height: '40px' } } value={selectSearchStartDate} onChange={(e) => setSelectSearchStartDate(e.target.value) } />
                            </div>
                            <div className="menu-keyword-sub-keyword" style={ { float: 'left', width: '12px', paddingLeft: '25px', paddingTop: '10px', fontSize:'15px', fontWeight:'bold' } }>
                                ~
                            </div>
                            <div className="menu-keyword-sub-keyword" style={ { float: 'left', width: '120px', paddingLeft: '12px' } }>
                                <input type="date" style={ { width: '120px', fontSize: '15px', height: '40px' } } value={selectSearchEndDate} onChange={(e) => setSelectSearchEndDate(e.target.value) } />
                            </div>
                            </>
                            :
                            <></>}
                        </div>
                        <div>
                            <div style={ { width: '100%', height: 'calc(100vh - 267px)', float: 'left', fontSize: '17px' } }>
                                <DataGrid
                                    className="grid_main"
                                    rows={rows}
                                    columns={columns}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    onRowSelectionModelChange={(newSelectedIds) => {
                                        setSelectProjectItemID(newSelectedIds[0]);
                                    }}
                                    columnVisibilityModel={columnVisibilityModel}
                                    AlternatingRowBackground="LavenderBlush"
                                    rowsPerPageOptions={[20, 50, 100]}
                                />
                            </div>                       
                        </div>
                    </div>
                    {selectSearchPerforamnce === 'N'? 
                    <></>:
                    <>
                    <div className="grid_sub" style={ { width: 'calc(100% - 1290px)', height: 'calc(100vh - 173px)', float: 'left', paddingLeft: '5px' } }>
                        <div style={ { display:'block', height:'90px' } }></div>
                        <div>
                            <div style={ { width: '100%', height: 'calc(100vh - 267px)', paddingLeft: '5px', float: 'right', fontSize: '17px' } }>
                                <DataGrid
                                    className="datagrid grid_main"
                                    rows={itemRows}
                                    columns={columnsItems}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    columnVisibilityModel={columnItemsVisibilityModel}
                                    AlternatingRowBackground="LavenderBlush"
                                    rowsPerPageOptions={[20, 50, 100]}
                                />
                            </div>                         
                        </div>
                    </div>
                    </>}
                    <div className="grid_sub" style={ {  width: '320px', height: 'calc(100vh - 173px)', float: 'right', paddingLeft: '10px', paddingRight: '10px', backgroundColor: '#f5f5f5', borderRadius:'5px' } }>
                        {fixProject !== ''?
                        <></>
                        :
                        <div style={ {  display:'block' } }>
                            <div className="menu-keyword-sub-keyword" style={ {  float: 'left', maxWidth: '100px', paddingTop: '10px' } }>
                                <select className="modal_filed_input_select" style={ { width: '145px', border:'2px solid lightgrey', borderRadius: '5px', fontSize:'17px', height:'40px' } } placeholder="일자" value={selectDateType} onChange={(e) => setSelectDateType(e.target.value) }>
                                    {dateTypeOption.map((item) => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="menu-keyword-sub-keyword" style={ { float:'right', paddingTop: '10px' } }>
                                <input type="date" placeholder="일자" style={ { paddingBlock: '0px', height: '40px', width: '145px' } } value={selectDate} onChange={(e) => setSelectDate(e.target.value) } />
                            </div>
                        </div>}
                        <div className="menu-keyword-sub-keyword" style={ { paddingTop: '10px', maxWidth: '500px' } }>
                            <select className="modal_filed_input_select" style={ { width: '300px', border:'2px solid lightgrey', borderRadius: '5px', fontSize:'17px', height:'40px' } } placeholder="프로젝트" value={selectProject} onChange={(e) => setSelectProject(e.target.value) }>
                                {projectOption.map((item) => (
                                    <option key={item.value} value={item.value}>{item.label}</option>
                                ))}
                            </select>
                        </div>
                        <table style={ { width: '100%', textAlign: 'center',paddingTop: '10px' } }>
                            <tbody>
                            <tr>
                                <td>
                                    <span style={ { fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>생산수량</span>
                                </td>
                                <td>
                                    <span style={ { fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>양품수량</span>
                                </td>
                                <td>
                                    <span style={ { fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' } }>불량수량</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={ { display:'inline' } }>
                                    <input type="number" style={ { width: '75px', height: '30px', fontSize: '17px', textAlign: 'right', fontWeight: 'bold' } } value={selectProduceCount} disabled />
                                </td>
                                <td>
                                    <input type="number" style={ { width: '75px', height: '30px', fontSize: '17px', textAlign: 'right', fontWeight: 'bold' } } value={selectProduceCompleteCount} onChange={(e) => ProduceCompleteCountUpdate(e) } disabled={selectProduceInputYN !== 'N'} />
                                </td>
                                <td>
                                    <input type="number" style={ { width: '75px', height: '30px', fontSize: '17px', textAlign: 'right', fontWeight: 'bold' } } value={selectProduceErrorCount} onChange={(e) => ProduceErrorCountUpdate(e) } disabled={selectProduceInputYN !== 'N'} />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        { InputItemRows.length == 0 ?
                        <></>
                        :
                        <>
                        <div style={ { display: 'block' } }>
                            <p style={ { fontSize: '24px', fontWeight: 'bold', marginTop:'10px', marginBottom: '5px' } }>사용 품목</p>
                        </div>
                        <div style={ { display: 'block' } }>
                            {InputItemRows.map((item) => (
                                <div style={ { paddingBottom: '10px', width: '300px' } }>
                                    <span style={ { fontSize: '18px' } }>{ item.produce_input_item_name}</span> <span style={ { fontSize: '15px' } }>{ item.produce_input_item_spec }</span>
                                    <span style={ { float: 'right' } }>
                                        <input type="number" style={ { width: '70px', fontSize: '15px', textAlign:'right', backgroundColor: 'white' } } value={item.produce_input_count} onChange={(e) => ProduceInputCountUpdate(item.produce_input_item_seq, e, item.produce_input_item_use_stock, item.produce_input_item_dp_use_stock, item.produce_input_item_unit_name) } disabled={selectProduceInputYN !== 'N'} />
                                    </span>
                                </div>
                            ))}
                        </div>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineProducePerformanceInfo;